import siteData from "../data/siteData.json";
import "./ProjectsPage.css";

export default function ProjectsPage() {
  return (
    <section className="projects-page">
      <h1 className="page-title">All Projects</h1>

      <div className="projects-grid">
        {siteData.projects.map((project, index) => (
          <div className="project-card" key={index}>
            <img src={project.image} alt={project.name} />
            <h3>{project.name}</h3>
            <p>{project.location}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
